<template>
  <div class="min-h-screen bg-gray-50">
    <div class="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <!-- Header -->
      <div class="mb-8">
        <button @click="goBack" class="flex items-center space-x-2 text-indigo-600 hover:text-indigo-700 mb-4 transition">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
          <span>Voltar</span>
        </button>
  <h1 class="text-3xl font-bold text-gray-900">Configurações do seu Ambiente</h1>
  
      </div>

      <!-- Formulário -->
      <div class="bg-white rounded-lg shadow-sm p-6">
        <form @submit.prevent="saveTenantSettings" class="space-y-6">
          <!-- Informações do TripDay -->
          <div>
            <h2 class="text-lg font-semibold text-gray-900 mb-4">Informações do Ambiente</h2>
            <div class="space-y-4">
              <div>
                <TenantLogoUpload
                  v-model="form.logo_url"
                  :company-name="form.name"
                  :tenant-name="form.name"
                  :tenant-phone="form.phone"
                  @upload-success="onLogoUploadSuccess"
                />
                <p class="text-center text-xs text-gray-500 mt-1">Essa foto será exibido na vitrine de imóveis.</p>
              </div>              
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Nome do seu Ambiente</label>
                <div class="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-lg text-gray-700 font-mono text-sm">
                  {{ form.master_code || '—' }}
                </div>
                <p class="text-xs text-gray-500 mt-1">Não pode ser alterado</p>
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Nome da sua Empresa *</label>
                <input
                  v-model="form.name"
                  type="text"
                  required
                  class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
                <span v-if="errors.name" class="text-red-500 text-sm">{{ errors.name }}</span>
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Telefone principal da empresa</label>
                <input
                  v-model="form.phone"
                  type="tel"
                  placeholder="(00) 00000-0000"
                  @input="onPhoneInput"
                  class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
                <p class="text-xs text-gray-500 mt-1">Exibido na vitrine de imóveis; usado no botão WhatsApp.</p>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Cidade</label>
                  <input
                    v-model="form.city"
                    type="text"
                    placeholder="Ex: São Paulo"
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">UF</label>
                  <select
                    v-model="form.state"
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  >
                    <option value="">Selecione</option>
                    <option
                      v-for="uf in stateOptions"
                      :key="uf.value"
                      :value="uf.value"
                    >
                      {{ uf.label }} ({{ uf.value }})
                    </option>
                  </select>
                </div>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Perfil do Instagram</label>
                  <input
                    v-model="form.instagram_profile"
                    type="text"
                    placeholder="Ex: https://instagram.com/seu_perfil"
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Perfil do Facebook</label>
                  <input
                    v-model="form.facebook_profile"
                    type="text"
                    placeholder="Ex: https://facebook.com/sua_pagina"
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- Mensagens -->
          <div v-if="successMessage" class="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg flex items-center space-x-2">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
            </svg>
            <span>{{ successMessage }}</span>
          </div>

          <div v-if="errors.general" class="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg flex items-center space-x-2">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
            </svg>
            <span>{{ errors.general }}</span>
          </div>

          <!-- Botões de ação -->
          <div class="flex justify-end space-x-3 pt-6 border-t border-gray-200">
            <button
              type="button"
              @click="goBack"
              class="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition font-medium"
            >
              Cancelar
            </button>
            <button
              type="submit"
              :disabled="saving"
              class="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition font-medium disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {{ saving ? 'Salvando...' : 'Salvar Alterações' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { navigateTo } from '../router.js'
import { useApi } from '../composables/useApi.js'
import { useBrazilianMasks } from '../composables/useBrazilianMasks.js'
import { BRAZILIAN_STATES } from '../constants/brazilianStates.js'
import TenantLogoUpload from './TenantLogoUpload.vue'

export default {
  components: { TenantLogoUpload },
  data() {
    return {
      form: {
        name: '',
        master_code: '',
        phone: '',
        city: '',
        state: '',
        instagram_profile: '',
        facebook_profile: '',
        logo_url: ''
      },
      stateOptions: BRAZILIAN_STATES,
      saving: false,
      successMessage: '',
      errors: {}
    }
  },

  mounted() {
    this.loadTenantData()
  },

  methods: {
    onPhoneInput(event) {
      const { handlePhoneInput } = useBrazilianMasks()
      handlePhoneInput(event, this.form)
    },

    loadTenantData() {
      const tenantData = localStorage.getItem('tenant')
      if (tenantData) {
        const tenant = JSON.parse(tenantData)
        this.form.name = tenant.name || ''
        this.form.master_code = tenant.master_code || ''
        this.form.phone = tenant.phone || ''
        this.form.city = tenant.city || ''
        this.form.state = tenant.state || ''
        this.form.instagram_profile = tenant.instagram_profile || ''
        this.form.facebook_profile = tenant.facebook_profile || ''
        this.form.logo_url = tenant.logo_url || ''
      }
    },

    onLogoUploadSuccess({ tenant }) {
      if (tenant) {
        const updatedTenant = {
          ...JSON.parse(localStorage.getItem('tenant') || '{}'),
          name: tenant.name,
          master_code: tenant.master_code,
          phone: tenant.phone || '',
          city: tenant.city || '',
          state: tenant.state || '',
          instagram_profile: tenant.instagram_profile || '',
          facebook_profile: tenant.facebook_profile || '',
          logo_url: tenant.logo_url || ''
        }
        localStorage.setItem('tenant', JSON.stringify(updatedTenant))
        this.form.logo_url = tenant.logo_url || ''
      }
    },

    async saveTenantSettings() {
      this.saving = true
      this.errors = {}
      this.successMessage = ''

      try {
        const { put } = useApi()
        const { data, error } = await put('/api/v1/tenant', {
          tenant: {
            name: this.form.name,
            phone: this.form.phone || '',
            city: this.form.city || '',
            state: this.form.state || '',
            instagram_profile: this.form.instagram_profile || '',
            facebook_profile: this.form.facebook_profile || ''
          }
        })

        if (error) {
          const errorList = error.response?.data?.errors
          if (Array.isArray(errorList)) {
            this.errors.general = errorList.join(', ')
          } else if (typeof errorList === 'object') {
            const firstKey = Object.keys(errorList)[0]
            this.errors.general = errorList[firstKey]?.[0] || 'Erro ao salvar configurações'
          } else {
            this.errors.general = errorList || 'Erro ao salvar configurações'
          }
          return
        }

        const updatedTenant = {
          ...JSON.parse(localStorage.getItem('tenant') || '{}'),
          name: data.name,
          master_code: data.master_code,
          phone: data.phone || '',
          city: data.city || '',
          state: data.state || '',
          instagram_profile: data.instagram_profile || '',
          facebook_profile: data.facebook_profile || '',
          logo_url: data.logo_url || ''
        }
        localStorage.setItem('tenant', JSON.stringify(updatedTenant))
        this.form.logo_url = data.logo_url || ''

        this.successMessage = 'Configurações atualizadas com sucesso!'
        setTimeout(() => { this.successMessage = '' }, 3000)
      } catch (err) {
        this.errors.general = 'Erro ao salvar configurações'
      } finally {
        this.saving = false
      }
    },

    goBack() {
      navigateTo('dashboard')
    }
  }
}
</script>
